import styled from 'styled-components';
import { colors } from '../colors';

interface buttonProps {
	roundButton?: boolean;
	// disabled?: boolean;
	margin?: string;
	block?: boolean;
	primary?: boolean;
	secondary?: boolean;
	default?: boolean;
	btnIcon?: boolean;
	btnIconOutline?: boolean;
	overlayButton?: boolean;
	btnImgIconSmall?: boolean;
	btnPrimary?: boolean;
	btnSecondaryOutline?: boolean;
	btnSecondaryOutlineDelete?: boolean;
	previousButton?: boolean;
	nextButton?: boolean;
	attachmentButton?: boolean;
	searchButton?: boolean;
	iconShow?: boolean;
	hide?: boolean;
	btnIconDelete?: boolean;
	btnIconView?: boolean;
	btnIconEdit?: boolean;
	linkButton?: boolean;
	archiveButton?: boolean;
	restoreButton?: boolean;
	subscribeButton?: boolean;
	enterpriseButton?: boolean;
	inlineButton?: boolean;
	portalButton?: boolean;
	renewButton?: boolean;
	btnTitleHeader?: boolean;
}

const Button = styled.button<buttonProps>`
	height: auto;
	font-size: 16px;
	min-height: 34px;
	padding: 0.25em 25px;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid transparent;
	white-space: nowrap;
	transition: ease-in all 0.3s;
	width: ${({ block }) => (block ? '100%' : 'auto')};
	margin: ${({ margin }) => margin};
	&.btn-default {
		border: 1px solid #abb8c3;
		background: none;
		color: #58728c;
		font-size: 13px;
		line-height: 11px;
		border-radius: 18px;
		height: 38px;
		display: flex;
		align-items: center;
		padding: 0.25em 14px;
		text-transform: capitalize;
		transition: 0.3s;
		&:hover,
		&:focus,
		&:active {
			background: #55a8fe !important;
			border: 1px solid #55a8fe !important;
			color: #fff !important;
		}
		span {
			margin: -1px 6px 0 0;
			font-size: 13px;
		}
	}
	${({ iconShow }) =>
		iconShow &&
		`padding: 4px;
		height: auto;
		top: 0;
		right: 0;
        background: transparent;
    `};
	${({ hide }) => hide && `display:none !important;`};
	${({ inlineButton }) =>
		inlineButton && `display: table-cell;vertical-align: middle; margin: 15px 10px 15px 0;`};
	${({ roundButton }) => roundButton && `border-radius:100%; `};
	${({ secondary }) => secondary && `background-color:${colors.GreenBase}; `};
	${({ btnIcon }) =>
		btnIcon &&
		`position: absolute;
		padding: 0;
		height: auto;
		top: 0;
		right: 0;
		background: transparent;
		padding: 4px;
		margin: 8px;
		:hover{
			background-color:${colors.BlueBase};
			border:1px solid ${colors.BlueBase}
			color: ${colors.White};
			span, span::before {
				color: ${colors.White};
			}
		}
	`};
	${({ primary }) =>
		primary &&
		`background-color:${colors.BlueDark};
		border:1px solid ${colors.BlueDark};
		color: ${colors.White}!important;
		:hover{
			background-color:${colors.BlueBase};
			border:1px solid ${colors.BlueBase};
		}
	`};
	${({ disabled }) =>
		disabled &&
		`cursor: not-allowed;
	opacity:0.5;
    `};
	${({ btnPrimary }) =>
		btnPrimary &&
		`background-color:${colors.BlueDark};		
		border:1px solid ${colors.BlueDark};
		color: ${colors.White}!important;
		:hover{
			background-color:${colors.BlueBase};
			border:1px solid ${colors.BlueBase};
		}
	`};
	${({ btnSecondaryOutline }) =>
		btnSecondaryOutline &&
		`background-color:${colors.White};
		border:1px solid ${colors.GreyAB};
		color: ${colors.Grey58}!important;
		:hover{
			background-color:${colors.GreyF5};
			border:1px solid ${colors.BlueBase};
			color: ${colors.White};

		}
	`};
	${({ btnSecondaryOutlineDelete }) =>
		btnSecondaryOutlineDelete &&
		`background-color:${colors.White};
		border:1px solid ${colors.GreyAB};
		color: ${colors.Grey58}!important;
		:hover{
			background-color:${colors.GreyF5};
			border:1px solid red;
			color: ${colors.White};

		}
	`};
	${({ btnIconOutline }) =>
		btnIconOutline &&
		`padding: 0;
		background-color:${colors.GreyF6};
		border:1px solid ${colors.GreyAB}!important;
		height: 38px;
		padding: 4px 16px;
		border-radius: 50px;
		font-size: 13px;
		line-height: 15px;
		color: ${colors.Grey58};
		span{
			margin-right:7px;
		}
		:hover{
			background-color:${colors.BlueBase};
			border:1px solid ${colors.BlueBase};
			color: ${colors.White};
		}
	`};
	${({ overlayButton }) =>
		overlayButton &&
		`
		background-color:${colors.GreyF6};
		border:1px solid ${colors.BlueBase}!important;
		min-height: 32px !important;
    	padding: 0.25em 25px !important;
		border-radius: 50px;
		font-size: 13px;
		line-height: 15px;
		color: ${colors.BlueBase};
		span{
			margin-right:7px;
		}
		:hover{
			background-color:${colors.BlueBase};
			border:1px solid ${colors.BlueBase};
			color: ${colors.White};
		}
	`};
	${({ btnImgIconSmall }) =>
		btnImgIconSmall &&
		`img{
			width:13px;
			margin-right:5px;
		}
	`};
	${({ previousButton }) =>
		previousButton &&
		`left:-30px;
		position:absolute;

	`};
	${({ nextButton }) =>
		nextButton &&
		`right:-30px;
		position:absolute;
	`};
	${({ searchButton }) =>
		searchButton &&
		`width: 116px;
		height: 34px;
		background-color:${colors.BlueDark};
		color: ${colors.White};
		border-radius: 18px;
		font-size: 15px;
		line-height: 18px;
		font-family: 'RubikMedium';
		margin: 34px 0 0 16px;
		:hover{
			background-color:${colors.BlueBase};
		}
	`};
	${({ subscribeButton }) =>
		subscribeButton &&
		`width: auto;
		height: 34px;
		background-color:${colors.BlueDark};
		color: ${colors.White};
		border-radius: 18px;
		font-size: 15px;
		line-height: 18px;
		font-family: 'RubikMedium';
		margin: 15px auto 15px auto;
		display: table;
		:hover{
			background-color:${colors.BlueBase};
		}
	`};
	${({ enterpriseButton }) =>
		enterpriseButton &&
		`width: auto;
		height: 34px;
		background-color:${colors.BlueDark};
		color: ${colors.White};
		border-radius: 18px;
		font-size: 15px;
		line-height: 18px;
		font-family: 'RubikMedium';
		display: inline-block;
		:hover{
			background-color:${colors.BlueBase};
		}
	`};
	${({ portalButton }) =>
		portalButton &&
		`width: auto;
		height: 30px;
		min-height: 30px;
		background-color: ${colors.BlueDark};
		color:  ${colors.White};
		border-radius: 18px;
		font-size: 12px;
		line-height: 12px;
		font-family: 'RubikMedium';
		display: inline-block;
		top: 10px;
		right: 10px;
		float: right;
		:hover{
			background-color:${colors.BlueBase};
		}
	`};
	${({ renewButton }) =>
		renewButton &&
		`width: auto;
		height: 30px;
		min-height: 30px;
		background-color: ${colors.BlueDark};
		color:  ${colors.White};
		border-radius: 18px;
		font-size: 12px;
		line-height: 12px;
		font-family: 'RubikMedium';
		display: inline-block;
		margin-top: 10px;
		margin-right: 15px;
		:hover{
			background-color:${colors.BlueBase};
		}
	`};
	${({ attachmentButton }) =>
		attachmentButton &&
		`position:relative;
		line-height: normal;
		padding: 10px 14px;
		height: auto;
		line-height: normal;
		min-height: auto;
		span{
			margin: -2px 5px 0 0;
    		font-size: 15px;
		}
		input[type="file"] {
			opacity: 0;
			position: absolute;
			width: 140px;
		}
		:hover{
			span{
				:before{
					color: ${colors.White};
				}
			}
		}
	`};
	${({ btnIconDelete }) =>
		btnIconDelete &&
		`padding: 3px!important;
		background: transparent;
		border:none;
		border-radius: 3px;
		color: ${colors.Grey58} !important;
		height:26px;
		width:26px;
		min-height:26px;
		span{
			padding:0!important;
			right:0!important;
			position:relative!important;
		}
		:hover,
		:active,
		:focus{
			background:${colors.Red}!important;
			border:1px solid ${colors.Red}!important;
			color: ${colors.White} !important;
			span{
				padding:0;
				right:0;
				:before{
					color: ${colors.White} !important;
				}
			}
		}
	`};
	${({ btnIconEdit }) =>
		btnIconEdit &&
		`padding: 3px!important;
		background: transparent;
		border:none;
		border-radius: 3px;
		color: ${colors.Grey58} !important;
		height:26px;
		width:26px;
		min-height:26px;
		span{
			padding:0!important;
			right:0!important;
			position:relative!important;
		}
		:hover,
		:active,
		:focus{
			background:${colors.Blue13}!important;
			border:1px solid ${colors.Blue13}!important;
			color: ${colors.White} !important;
			span{
				padding:0;
				right:0;
				:before{
					color: ${colors.White} !important;
				}
			}
		}
	`};
	${({ btnIconView }) =>
		btnIconView &&
		`padding: 3px!important;
		background: transparent;
		border:none;
		border-radius: 3px;
		color: ${colors.Grey58} !important;
		height:26px;
		width:26px;
		min-height:26px;
		span{
			padding:0!important;
			right:0!important;
			position:relative!important;
		}
		:hover,
		:active,
		:focus{
			background:${colors.Blue13}!important;
			border:1px solid ${colors.Blue13}!important;
			color: ${colors.White} !important;
			span{
				padding:0;
				right:0;
				:before{
					color: ${colors.White} !important;
				}
			}
		}
	`};
	${({ linkButton }) =>
		linkButton &&
		`background: transparent;
		padding: 0;
		height: auto;
		width: auto;
		color: ${colors.BlueBase};
		line-height: 16px;
		text-transform: none;
		text-decoration:none;
		&:hover{
			color: ${colors.BlueDark};
			text-decoration: underline!important;
		}
	`}
	${({ archiveButton }) =>
		archiveButton &&
		`background: transparent;
	margin-left: auto;
	padding: 0;
	padding-right: 5px !important;
	height: auto;
	width: auto;
	color: ${colors.Red};
	line-height: 16px;
	text-transform: none;
	text-decoration:none;
	&:hover{
		color: ${colors.Red1};
		text-decoration: underline!important;
	}
`}
	${({ restoreButton }) =>
		restoreButton &&
		`background: transparent;
margin-left: auto;
padding: 0;
padding-right: 5px !important;
height: auto;
width: auto;
color: ${colors.GreenBase};
line-height: 16px;
text-transform: none;
text-decoration:none;
&:hover{
color: ${colors.GreenDark};
text-decoration: underline!important;
}
`}
	${({ btnIconEdit }) =>
		btnIconEdit &&
		`padding: 3px!important;
		background: transparent;
		border:none;
		border-radius: 3px;
		color: ${colors.Grey58} !important;
		height:26px;
		width:26px;
		min-height:26px;
		span{
			padding:0!important;
			right:0!important;
			position:relative!important;
		}
		:hover,
		:active,
		:focus{
			background:${colors.BlueBase}!important;
			border:1px solid ${colors.BlueBase}!important;
			color: ${colors.White} !important;
			span{
				padding:0;
				right:0;
				:before{
					color: ${colors.White} !important;
				}
			}
		}
	`}
	${({ btnTitleHeader }) =>
		btnTitleHeader &&
		`background-color:${colors.White};
		border:1px solid ${colors.GreyAB};
		color: ${colors.Grey58}!important;
		border-radius: 1px;
		:hover,
		:focus,
		:active{
			background-color:${colors.GreyF5};
			border:1px solid ${colors.BlueBase};
			color: ${colors.BlueBase};

		}		
		&.header-btn-active {
			background-color:${colors.BlueBase};
			border:1px solid ${colors.BlueBase};
			color: ${colors.White} !important;
		}
	`};
`;

export default Button;
